import { z } from "zod"
import { type Column, columnSchema, DEFAULT_COLUMNS, withName } from "./columns"
import { type Grouping, groupingSchema } from "./grouping"

export const DIRECTORY = { limit: 1000 }

export function directoryOf({ archived }: { archived?: boolean }): {
  limit: number
  archived?: boolean
} {
  return archived ? { ...DIRECTORY, archived: true } : DIRECTORY
}

const directionSchema = z.enum(["asc", "desc"])

export type Direction = z.infer<typeof directionSchema>

export const customerSearchSchema = z.object({
  archived: z.boolean().optional().catch(false),
  search: z.string().optional().catch(undefined),
  country: z.array(z.string()).optional().catch(undefined),
  kind: z.array(z.string()).optional().catch(undefined),
  group: groupingSchema.optional().catch(undefined),
  subgroup: groupingSchema.optional().catch(undefined),
  columns: z.array(columnSchema).optional().catch(undefined),
  sort: columnSchema.optional().catch(undefined),
  direction: directionSchema.optional().catch(undefined),
})

export type CustomerSearch = z.infer<typeof customerSearchSchema>

export type CustomerDisplay = {
  group: Grouping | undefined
  subgroup: Grouping | undefined
  columns: Column[]
  sort: Column
  direction: Direction
}

export function displayOf(search: CustomerSearch): CustomerDisplay {
  const group = search.group
  return {
    group,
    subgroup: group && search.subgroup !== group ? search.subgroup : undefined,
    columns: search.columns ? withName(search.columns) : DEFAULT_COLUMNS,
    sort: search.sort ?? "name",
    direction: search.direction ?? "asc",
  }
}
